import React from 'react';
import {injectIntl} from 'react-intl';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './EvidenceProofConfirmModal.module.css';

const cx = classNames.bind(styles);

const EvidenceProofConfirmModal = ({intl, isOpen, onCancel, onConfirm}) => {
  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = event => {
    if (event.target === event.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className={cx('modal-backdrop', 'modal-backdrop--centered')} onClick={handleBackdropClick}>
      <div className={cx('modal-panel', 'modal-panel--centered', 'confirmModalPanel')}>
        <button
          type="button"
          aria-label={intl.messages['app.support.disputes.proof-form.confirm-modal.close']}
          onClick={onCancel}
          className={cx('confirmModalClose')}>
          ×
        </button>
        <h2 className={cx('confirmModalTitle')}>
          {intl.messages['app.support.disputes.table.send-proof']}
        </h2>
        <div className={cx('confirmModalDesc')}>
          {intl.messages['app.support.disputes.table.send-proof-confirmation']}
        </div>
        <div className={cx('confirmModalActions')}>
          <button
            type="button"
            onClick={onCancel}
            className={cx('confirmModalButton', 'confirmModalButtonCancel')}>
            {intl.messages['app.support.disputes.proof-form.cancel.button']}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={cx('confirmModalButton', 'confirmModalButtonSend')}>
            {intl.messages['app.support.disputes.proof-form.confirm-modal.send']}
          </button>
        </div>
      </div>
    </div>
  );
};

EvidenceProofConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    messages: PropTypes.object.isRequired
  }).isRequired
};

export default injectIntl(EvidenceProofConfirmModal);
